import type { GetDashboardClientsPageQuery, Client } from 'generated/graphql';
import activityFlags from 'sharedHelpers/activityFlags';
import { clientsList } from '../../pages/client/dataTransforms';

type ClientsConnectionForTransform = Parameters<typeof clientsList>[0];

export default (
  connection: GetDashboardClientsPageQuery['getClients']
): Client[] => {
  const connectionForTransform = (connection as unknown) as ClientsConnectionForTransform;

  return clientsList(connectionForTransform).map((client) => ({
    ...client,
    activity: activityFlags(
      client.lastReceivedTimestamp,
      client.lastOpenedTimestamp
    ),
  }));
};
